import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, firstValueFrom } from 'rxjs';
import { state } from '../+state/dealer/dealer.reducer';
import type { Dealer } from '../api/api-types';

export function titleResolver(title: (dealer: Dealer, store: Store) => Promise<string> | string) {
    return async () => {
        const store = inject(Store);
        const dealer = await firstValueFrom(store.select(state.selectLoadedDealer).pipe(filter((d) => !!d)));
        return `${await title(dealer, store)}`;
    };
}

export function extraDealerTitleResolver(title: (store: Store) => Promise<string> | string) {
    return titleResolver(async (dealer, store) => `${await title(store)} | ${dealer.name} ${dealer.city}`);
}
export function defaultTitleResolver(title: string | ((store: Store) => string)) {
    return titleResolver((dealer) => `${title} | ${dealer.name} in ${dealer.city}`);
}
